import { getAge, getDateOfBirth } from "utils/calculateAge";
import classNames from "utils/class-names";
import { FILTER_TYPE } from "utils/constants";
import generatedFormatDate from "utils/generatedDate";

const date = new Date();

const day = date.getDate();
const month = date.getMonth();
const year = date.getFullYear();

export const COLUMNS_DATA = ({
  deleteRow,
  editPatients,
  filters,
  isSuperFranchise,
  isFranchiseEmployee,
  isSubFranchise,
  membershipOrder,
  isSuperAdmin,
  isZoneB2C,
  membershipUpgrade,
}) => {
  const canShowMembership =
    isZoneB2C &&
    isSuperFranchise !== 1 &&
    isSubFranchise !== 1 &&
    isFranchiseEmployee !== 1;
  const columns = [
    {
      Header: "S.No",
      accessor: "_index",
      disableSortBy: true,
    },
    {
      Header: "Date",
      accessor: "generated",
      disableSortBy: true,
      Cell: ({ value }) => generatedFormatDate(value),
    },
    {
      Header: "Reg No",
      accessor: "registration_no",
      disableSortBy: true,
    },
    {
      Header: "Patient Name",
      accessor: "patient_name",
      disableSortBy: true,
    },
    {
      Header: "Age",
      accessor: "age",
      disableSortBy: true,
      Cell: ({ cell }) => {
        const { age } = cell.row.original;

        if (!age) return "";

        return `${age.year}y ${age.month}m ${age.days}d`;
      },
    },
    {
      Header: "Gender",
      accessor: "gender",
      disableSortBy: true,
      Cell: ({ row }) => {
        const rawGender = row.original?.gender || "";

        const gender = rawGender
          ? rawGender.toLowerCase().replace(/^\w/, (c) => c.toUpperCase())
          : "";

        return gender;
      },
    },
    {
      Header: "Refer Doctor",
      accessor: "refer_doctor_obj.doctor_name",
      disableSortBy: true,
    },
    ...(canShowMembership
      ? [
          {
            Header: "Membership Card No",
            accessor: "memberships_orders",
            disableSortBy: true,
            Cell: ({ value }) =>
              value?.length > 0
                ? value.map((item, index) => (
                    <div key={index}>{item?.membership_card_no || ""}</div>
                  ))
                : "",
          },
        ]
      : []),
    {
      Header: "Mobile Number",
      accessor: "mobile",
      disableSortBy: true,
    },
    {
      Header: "Address",
      accessor: "address",
      disableSortBy: true,
    },
    {
      Header: "Area Name",
      accessor: "area_obj.area_name",
      disableSortBy: true,
    },
    {
      Header: "City",
      accessor: "city",
      disableSortBy: true,
    },
    {
      Header: "State",
      accessor: "state_obj.state",
      disableSortBy: true,
    },
    {
      Header: "Country",
      accessor: "country_master_obj.country",
      disableSortBy: true,
    },
    {
      Header: "Franchise Name",
      accessor: "franchise_name",
      disableSortBy: true,
    },
    {
      Header: "Date Of Birth",
      accessor: "dob",
      disableSortBy: true,
    },
    {
      Header: "Email ID",
      accessor: "email",
      disableSortBy: true,
    },
    {
      Header: "Comments",
      accessor: "comments",
      disableSortBy: true,
    },
    {
      Header: "Doctor Type",
      accessor: "doctor_type",
      disableSortBy: true,
    },
    {
      Header: "Collection Type",
      accessor: "collection_type_obj.collection_type",
      disableSortBy: true,
    },
    {
      Header: "Dispatch Mode",
      accessor: "dispatch_mode",
      disableSortBy: true,
    },
    {
      Header: "Created By",
      accessor: "created_by_name",
      disableSortBy: true,
    },
    {
      Header: "Zone",
      accessor: "zone_name",
      disableSortBy: true,
    },
    {
      Header: "",
      accessor: "ids",
      disableSortBy: true,
      Cell: ({ cell }) => {
        return (
          <>
            <button
              disabled={!filters.is_active}
              className={classNames("btn dropdown-toggle", {
                "btn-primary": filters.is_active,
                "btn-secondary": !filters.is_active,
              })}
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              More...
            </button>
            <ul className="dropdown-menu">
              <li>
                <button
                  className="dropdown-item"
                  onClick={() => editPatients(cell.row.original)}
                >
                  Edit
                </button>
              </li>
              {isSuperAdmin &&
                isSuperFranchise != 1 &&
                isFranchiseEmployee != 1 &&
                isSubFranchise != 1 && (
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => deleteRow(cell.row.original)}
                    >
                      Delete
                    </button>
                  </li>
                )}
              {isZoneB2C &&
                isSuperFranchise !== 1 &&
                isSubFranchise !== 1 &&
                isFranchiseEmployee !== 1 && (
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => membershipOrder(cell.row.original)}
                    >
                      Membership Order
                    </button>
                  </li>
                )}
              {isZoneB2C &&
                isSuperFranchise !== 1 &&
                isSubFranchise !== 1 &&
                isFranchiseEmployee !== 1 &&
                cell.row.original?.memberships_orders?.length > 0 && (
                  <li>
                    <button
                      className="dropdown-item"
                      onClick={() => membershipUpgrade(cell.row.original)}
                    >
                      Upgrade Membership
                    </button>
                  </li>
                )}
            </ul>
          </>
        );
      },
    },
  ];
  return columns;
};

export const PAYMENTS_COLUMNS_DATA = ({}) => [
  {
    Header: "S.No",
    accessor: "_index",
    disableSortBy: true,
    Cell: ({ row }) => row.index + 1,
  },
  {
    Header: "Id",
    accessor: "id",
    disableSortBy: true,
  },
  {
    Header: "Date",
    accessor: "generated",
    disableSortBy: true,
    Cell: ({ value }) => generatedFormatDate(value),
  },
  {
    Header: "Payment Mode",
    accessor: "payment_mode",
    disableSortBy: true,
  },
  {
    Header: "Bank Name",
    accessor: "bank_name",
    disableSortBy: true,
  },
  {
    Header: "Amount",
    accessor: "amount",
    disableSortBy: true,
  },
  {
    Header: "Cheque Or Card No",
    accessor: "cheque_or_card_no",
    disableSortBy: true,
  },
  {
    Header: "Created By Name",
    accessor: "created_by_name",
    disableSortBy: true,
  },
];

export const OPTIONS = [
  { key: "patient_name", value: "Patient Name" },
  { key: "gender", value: "Gender" },
  { key: "city", value: "City" },
  { key: "mobile", value: "Mobile" },
  { key: "email", value: "Email" },
  { key: "comments", value: "Comments" },
  { key: "doctor_type", value: "Doctor Type" },
  { key: "registeration_no", value: "Registration No." },
  { key: "dispatch_mode", value: "Dispatch Mode" },
];

export const STATUS_OPTIONS = [
  { key: true, value: "Active" },
  { key: false, value: "In-Active" },
];

const IS_WORKING_OPTIONS = [
  { key: true, value: "Yes" },
  { key: false, value: "No" },
];

export const FILTER_DEFINATIONS = [
  {
    name: "keyword",
    type: FILTER_TYPE.SELECT,
    initialValue: OPTIONS[0].key,
  },
  {
    name: "text",
    type: FILTER_TYPE.TEXT,
    initialValue: "",
    debounce: true,
  },
  {
    name: "is_active",
    type: FILTER_TYPE.SELECT,
    initialValue: STATUS_OPTIONS[0].key,
  },
];

export const PATIENT_FORM_CONFIG = (rowData) => {
  console.log("rowData", rowData);
  return [
    {
      label: "Patient Name",
      type: "input-text",
      name: "patient_name",
      defaultValue: rowData?.patient_name || "",
      capitalize: true,
      validations: {
        maxLength: 255,
        required: true,
      },
    },
    {
      label: "Age",
      type: "input-text-age",
      name: "age",
      calculates: "dob",
      defaultValue:
        rowData?.age && typeof rowData.age === "object"
          ? `${rowData.age.year}-${rowData.age.month}-${rowData.age.days}`
          : "",
      validations: {
        maxLength: 255,
        required: true,
      },
    },
    {
      label: "Date Of Birth",
      type: "input-date-dob",
      name: "dob",
      calculates: "age",
      defaultValue: rowData?.dob,
      validations: {
        maxLength: 255,
        required: true,
      },
    },
    // {
    //   label: "Gender",
    //   type: "input-text",
    //   name: "gender",
    //   defaultValue: rowData?.gender || "",
    //   validations: {
    //     maxLength: 255,
    //     required: true,
    //   },
    // },
    {
      label: "Gender",
      type: "select",
      name: "gender",
      defaultValue: "Both",
      options: [
        { key: "Male", value: "Male", label: "Male" },
        { key: "Female", value: "Female", label: "Female" },
        {
          key: "Transgender",
          value: "Transgender",
          label: "Transgender",
        },
      ],
      validations: {
        maxLength: 255,
        required: true,
      },
    },
    {
      label: "Address",
      type: "input-text",
      name: "address",
      defaultValue: rowData?.address || "",
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    // {
    //   label: "Area",
    //   type: "select",
    //   name: "area",
    //   defaultValue: rowData?.area_id || "",
    //   options: [],
    //   validations: {
    //     maxLength: 255,
    //     required: false,
    //   },
    // },
    {
      label: "City",
      type: "input-text",
      name: "city",
      defaultValue: rowData?.city || "",
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "State",
      type: "select",
      name: "state",
      defaultValue: rowData?.state_id || "",
      options: [],
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Mobile Number",
      type: "input-text",
      name: "mobile",
      defaultValue: rowData?.mobile || "",
      validations: {
        maxLength: 13,
        required: false,
        regex: /^(?:\+91|0)?[0-9]{10}$/,
      },
    },
    {
      label: "Email ID",
      type: "input-text",
      name: "email",
      defaultValue: rowData?.email || "",
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Comments",
      type: "input-text",
      name: "comments",
      defaultValue: rowData?.comments || "",
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Refer Doctor",
      type: "select",
      name: "refer_doctor_name",
      defaultValue: rowData?.refer_doctor_id || "",
      options: [],
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Doctor Type",
      type: "input-text",
      name: "doctor_type",
      defaultValue: rowData?.doctor_type || "",
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Collection Type",
      type: "select",
      name: "collection_type",
      defaultValue: rowData?.collection_type_id || "",
      options: [],
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Registration Number",
      type: "input-text",
      name: "registeration_no",
      defaultValue: rowData?.registeration_no || "",
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Dispatch Mode",
      type: "input-text",
      name: "dispatch_mode",
      defaultValue: rowData?.dispatch_mode || "",
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Zone",
      type: "select",
      name: "zone_id",
      defaultValue: rowData?.zone_id || "",
      selectedZone: true,
      options: [],
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Franchise",
      type: "select",
      name: "franchise_dropdown",
      defaultValue: rowData?.franchise_id || "",
      loginUser: true,
      options: [],
      zone_wise: true,
      validations: {
        required: true,
      },
    },
  ];
};

export const PATIENT_MEMBERSHIP_ORDER_FORM_CONFIG = (rowData) => {
  const today = new Date();

  const nextYearDate = new Date(
    today.getFullYear() + 1,
    today.getMonth(),
    today.getDate(),
  );

  const yyyy = nextYearDate.getFullYear();
  const mm = String(nextYearDate.getMonth() + 1).padStart(2, "0");
  const dd = String(nextYearDate.getDate()).padStart(2, "0");

  const defaultValidTill = `${yyyy}-${mm}-${dd}`;

  return [
    {
      label: "Order Membership",
      type: "select",
      name: "membership_id",
      defaultValue: rowData?.membership_id || "",
      options: [],
      validations: {
        maxLength: 255,
        required: true,
      },
    },
    {
      label: "Annual Fees",
      type: "input-number",
      name: "annual_fees",
      defaultValue: rowData?.annual_fees || "",
      validations: {
        maxLength: 255,
        required: true,
      },
    },
    {
      label: "Discount Percentage",
      type: "input-number",
      name: "discount_percentage",
      defaultValue: rowData?.discount_percentage || "",
      validations: {
        maxLength: 255,
        required: true,
      },
    },
    {
      label: "Valid Till",
      type: "input-date",
      name: "valid_till",
      defaultValue: rowData?.valid_till || defaultValidTill,
      validations: {
        maxLength: 255,
        required: true,
      },
    },
    {
      label: "Membership Card No",
      type: "input-text",
      name: "membership_card_no",
      defaultValue: rowData?.membership_card_no || "",
      validations: {
        maxLength: 255,
        required: true,
      },
    },
    {
      label: "Bank Name",
      type: "input-text",
      name: "bank_name",
      defaultValue: rowData?.payment_objs?.[0]?.bank_name || "",
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Payment Mode",
      type: "select",
      name: "payment_mode_id",
      defaultValue: rowData?.payment_objs?.[0]?.payment_mode_id || "",
      validations: {
        maxLength: 255,
        required: true,
      },
    },
    {
      label: "Cheque Or Card No",
      type: "input-text",
      name: "cheque_or_card_no",
      defaultValue: rowData?.payment_objs?.[0]?.cheque_or_card_no || "",
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Zone",
      type: "select",
      name: "zone_id",
      defaultValue: rowData?.zone_id || "",
      options: [],
      validations: {
        maxLength: 255,
        required: true,
      },
    },
    {
      label: "Comment",
      type: "input-text",
      name: "comment",
      defaultValue: "",
      validations: {
        maxLength: 500,
        required: false,
      },
    },
  ];
};

export const PATIENT_MEMBERSHIP_UPGRADE_FORM_CONFIG = (rowData) => {
  const today = new Date();

  const nextYearDate = new Date(
    today.getFullYear() + 1,
    today.getMonth(),
    today.getDate(),
  );

  const yyyy = nextYearDate.getFullYear();
  const mm = String(nextYearDate.getMonth() + 1).padStart(2, "0");
  const dd = String(nextYearDate.getDate()).padStart(2, "0");

  const defaultValidTill = `${yyyy}-${mm}-${dd}`;

  return [
    {
      label: "Order Membership",
      type: "select",
      name: "membership_id",
      defaultValue: "",
      options: [],
      validations: {
        maxLength: 255,
        required: true,
      },
    },
    {
      label: "Annual Fees",
      type: "input-number",
      name: "annual_fees",
      defaultValue: "",
      validations: {
        maxLength: 255,
        required: true,
      },
    },
    {
      label: "Discount Percentage",
      type: "input-number",
      name: "discount_percentage",
      defaultValue: "",
      validations: {
        maxLength: 255,
        required: true,
      },
    },
    {
      label: "Valid Till",
      type: "input-date",
      name: "valid_till",
      defaultValue: defaultValidTill,
      validations: {
        maxLength: 255,
        required: true,
      },
    },
    {
      label: "Membership Card No",
      type: "input-text",
      name: "membership_card_no",
      defaultValue: "",
      validations: {
        maxLength: 255,
        required: true,
      },
    },
    {
      label: "Payment Mode",
      type: "select",
      name: "payment_mode_id",
      defaultValue: "",
      validations: {
        maxLength: 255,
        required: true,
      },
    },
    {
      label: "Amount",
      type: "input-number",
      name: "amount",
      defaultValue: "",
      validations: {
        maxLength: 255,
        required: true,
      },
    },
    {
      label: "Cheque Or Card No",
      type: "input-text",
      name: "cheque_or_card_no",
      defaultValue: "",
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Bank Name",
      type: "input-text",
      name: "bank_name",
      defaultValue: "",
      validations: {
        maxLength: 255,
        required: false,
      },
    },
    {
      label: "Zone",
      type: "select",
      name: "zone_id",
      defaultValue: rowData?.zone_id || "",
      options: [],
      validations: {
        maxLength: 255,
        required: true,
      },
    },
    {
      label: "Comment",
      type: "input-text",
      name: "comment",
      defaultValue: "",
      validations: {
        maxLength: 500,
        required: false,
      },
    },
  ];
};
